// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s7ERq","type":"styles_type__119cU","choices":"styles_choices__3DoX5"};